import { CommonTranslations } from "./commonTranslations";

export const enCommonTranslations: CommonTranslations = {
  "opcUa_BadNoData_title": "Error loading events",
  "opcUa_BadNoData_text": "{}: Archiving is disabled in the events archive settings",
  "subscription_error": "Insufficient permissions to perform the action: Read value: ({})",
  "call_pou_error": 'Unable to perform the action "Call program"',
  "call_pou_error_rights": "Insufficient permissions to perform the action: Call program: (id {})",
  "write_data_error": "Unable to write the parameter value",
  "write_data_error_rights": "Insufficient permissions to perform the action: Write value: (id {})",
  /* Main*/
  "main_connectionServer": "Connecting to server...",
  "main_noConnectionServer": "No connection to server...",
  "main_connectingBackupNode": "Connecting to redundant node...",
  "main_reboot": "Reboot...",
  "main_connectionEstablished": "Connection established",
  "main_connectingTo": "Connection to",
  "main_successfullyInstalled": "successfully established",
  "confirm_the_operation": "Confirm the operation",
  /* Authorization*/
  "authorization_loginFormTitle": "Login",
  "authorization_loginTitle": "User",
  "authorization_passwordTitle": "Password",
  "authorization_showPasswordTitle": "Show password",
  "authorization_loginError": "Wrong password. Check keyboard layout or Caps Lock key.",
  "authorization_wrongPassword": "Wrong password.",
  "authorization_needChangePassword": "Password must be changed.",
  "authorization_newPassword": "New password",
  "authorization_repeatPassword": "Repeat password",
  "authorization_loginBtn": "Log in",
  "authorization_information": "Information",
  "authorization_error_newPasswordNoSpecified": "New password was not specified",
  "authorization_error_PasswordsNomatch": "Password mismatch",
  "authorization_changingUser": "User change",
  "authorization_error_loginError": "User login error",
  "authorization_blockingAccessSystem": "System access blocking",
  "authorization_sessionDuration": "Session duration",
  "authorization_passwordMinSize": "Minimum password length ",
  "authorization_passwordNonRepeatingCount": "Number of non-repeating passwords",
  "authorization_passwordExpirationTime": "Password validity period",
  "authorization_passwordIsComplex": "Use complex password",
  "authorization_passwordContainSpec": "Password must contain a special character",
  "authorization_logout": "Logout",
  "authorization_log_pass_error": "Invalid username or password",
  "authorization_log_error": "Login error",
  /*session*/
  "session_endSession": "Logout",
  "session_complete": "Log out",
  /*Trend toolbar*/
  "trend_toolbar_autoscroll": "Autoscroll",
  "trend_toolbar_objTree": "Object tree",
  "trend_toolbar_importCSV": "Open file to display on trend",
  "trend_toolbar_table": "Table",
  "trend_toolbar_export": "Export",
  "trend_toolbar_pageContols": "Page switching",
  "trend_toolbar_install": "Set",
  "trend_toolbar_clearMark": "Reset",
  "trend_toolbar_kits": "Pen sets",
  "trend_toolbar_log_disable": "Logarithmic scale",
  "trend_toolbar_log_active": "Logarithmic scale included",
  "trend_toolbar_ydatazoom_disable": "Scaling the canvas along the Y axis",
  "trend_toolbar_ydatazoom_active": "Canvas Y axis scaling enabled",
  "trend_toolbar_xdatazoom_disable": "Scaling the canvas along the X axis",
  "trend_toolbar_xdatazoom_active": "Canvas Y axis scaling enabled",
  "trend_toolbar_group": "Groups",
  "trend_toolbar_minilegenda": "Mini legend",
  "trend_toolbar_print": "Print",
  "trend_toolbar_exportGraph": "Graph export",
  "trend_toolbar_reset": "Reset",
  /*trend kits*/
  "trend_kits_saveKit": "Save pen set",
  "trend_kits_choseKit": "Select pen set",
  "trend_kits_reset": "Reset",
  "trend_kits_errorUpload": "A pen set with this name already exists",
  "trend_kits_existAlert1": "Pen set",
  "trend_kits_existAlert2": "already exists, rewrite? ",
  "trend_kits_uploadKit": "Load pen set",
  "trend_kits_deleteSelectedKit": "Delete selected pen set",
  "trend_kits_newKit": "New pen set",
  "trend_kits_renameTooltip": "Double-click to rename",
  "trend_kits_KitNoCreate": "Pen sets were not created",
  "trend_kits_want_delete_set": 'Are you sure you want to delete the set?',
  "trend_kits_no_sets_created": "No sets created",
  "trend_kits_select_set": "Select a set",
  /* trend kits modal-template*/
  "trend_kits_modal_save": "Save",
  "trend_kits_modal_cancel": "Cancel",
  //trend group
  "trend_group_main_pen_tooltip": "The pen is assigned as the main one in the group",
  "trend_group_all_pen": "All pens",
  "trend_group_title": "Group",
  "trend_group_no_group": "No groups",
  "trend_group_groups_pen": "Groups pen",
  "trend_group_create_tooltip": "Create a new group",
  "trend_group_edit_tooltip": "Edit selected group",
  "trend_group_delete_tooltip": "Delete selected group",
  //выбор перьев тренда
  "trend_objectTree_title": "Choosing pens",
  "trend_objectTree_title_obj": "Selecting objects",
  /*Trend mini legend*/
  "trend_legend_titleMinilegend": "Mini legend",
  "trend_legend_checkbox": "On",
  "trend_legend_title": "Name",
  "trend_legend_value": "Value",
  "trend_legend_color": "Color",
  //trend pen
  "trend_pen_no_archived": "Not archived",
  /*trend table*/
  "trend_table_time": "Time",
  "trend_table_show": "Table of values",
  "trend_table_interpol": "Display step",
  "trend_table_clear": "Reset",
  "trend_table_lable_values": "Table of values ​​(selected interval)",
  "trend_table_select_step": "Select display step",
  "trend_table_scale_tooltip": "Data interpolation period multiplier",
  //trend comtrade
  "trend_comtrade_title_modal": "Import waveform",
  "trend_comtrade_title_format_modal": "Timestamp format",
  "trend_comtrade_title_upload_btn" : "Selecting waveform files",
  "trend_comtrade_upload_btn" : "Select files",
  "trend_comtrade_uploaded" : "Uploaded files",
  "trend_comtrade_upload_error" : "Not all files have been uploaded. You need to upload .cfg and .dat files",
  "trend_comtrade_parsing_error" : "The imported files are corrupted or in an invalid format",
  /*trend interval selectDefault*/
  "trend_timeInterval_create": "Create",
  "trend_timeInterval_sort": "Sort",
  "trend_timeInterval_all": "All data",
  "trend_timeInterval_select_day": "1 Day",
  "trend_timeInterval_today" : "Today",
  "trend_timeInterval_today_tooltip" : "Go back to the current date and time",
  //trend error
  "trend_error": "Trend error",
  "trend_warning": "Trend warning",
  "trend_warning_not_all_added_params": "Not all parameters have been added to the trend",
  "trend_warning_not_added_exceed_limit": "not added) due to exceeding the limit",
  "trend_warning_no_one_added_params": "No parameters have been added trend",
  //add to trend error
  "add_to_trend_error": "Add to trend error",
  "trend_not_found": 'Trend not found',
  //chart
  "chart_XY_chart_is_empty": "Chart XY is empty",
  "chart_in_XY_chart": "In XY chart",
  "chart_missing_feathers": "missing feathers",
  //chartcolumn
  "chartcolumn_print_trend": "Print trend",
  "chartcolumn_creating_a_group_of_feathers": "Creating a group of feathers",
  "chartcolumn_chart_warning": "Chart warning",
  "chartcolumn_feather_limit": "Feather limit exceeded on diagram",
  "chartcolumn_pen": "Pen",
  "chartcolumn_was_not_added": "was not added",
  "chartcolumn_your_interval": "Your interval",
  "chartcolumn_selecting_standart_intervals": "Selecting standart intervals",
  "chartcolumn_print_to_printer": "Print to printer",
  "chartcolumn_print_diagram": "Print diagram",
  "chartcolumn_export_data": "Export data",
  //ChartGroups
  "chartgroup_group_name": "Group name",
  "chartgroup_cancel": "Cancel",
  "chartgroup_create_group": "Create group",
  "chartgroup_standart_group": "Standart group",
  "chartgroup_name_cannot_be_empty": "Name cannot be empty",
  "chartgroup_group_name_exists": "A group with this name already exists",
  //ChartIntervals
  "chartintervals_last_year": "Last year",
  "chartintervals_last_six_months": "The last six months",
  "chartintervals_current_month": "Current month",
  "chartintervals_last_week": "Last week",
  //ChartMenu
  "chartmenu_group_settings": "Group settings",
  "chartmenu_select_interval": "Select interval",
  "chartmenu_diagram_view": "Diagram view",
  "chartmenu_net": "Net",
  "chartmenu_value_scale": "Value scale",
  "chartmenu_autoscaling": "Autoscaling",
  "chartmenu_accumulation": "Accumulation",
  "chartmenu_reset_settings": "Reset settings",
  "chartmenu_save_image": "Save image",
  //ChartMenuInterval
  "interval_sunday": "Sunday",
  "interval_monday": "Monday",
  "interval_tuesday": "Tuesday",
  "interval_wednesday": "Wednesday",
  "interval_thursday": "Thursday",
  "interval_friday": "Friday",
  "interval_saturday": "Saturday",
  "interval_sun": "Sun",
  "interval_mon": "Mon",
  "interval_tue": "Tue",
  "interval_wed": "Wed",
  "interval_thur": "Thu",
  "interval_fri": "Fri",
  "interval_sat": "Sat",
  "interval_su": "Su",
  "interval_mo": "Mo",
  "interval_tu": "Tu",
  "interval_we": "We",
  "interval_th": "Th",
  "interval_fr": "Fr",
  "interval_sa": "Sa",
  "interval_january": "January",
  "interval_february": "February",
  "interval_march": "March",
  "interval_april": "April",
  "interval_may": "May",
  "interval_june": "June",
  "interval_july": "July",
  "interval_august": "August",
  "interval_september": "September",
  "interval_october": "October",
  "interval_november": "November",
  "interval_december": "December",
  "interval_jan": "Jan",
  "interval_feb": "Feb",
  "interval_mar": "Mar",
  "interval_apr": "Apr",
  "interval_ma": "May",
  "interval_jun": "Jun",
  "interval_jul": "Jul",
  "interval_aug": "Aug",
  "interval_sep": "Sep",
  "interval_oct": "Oct",
  "interval_nov": "Nov",
  "interval_dec": "Dec",
  "interval_today": "Today",
  "interval_clear": "Clear",
  "interval_division": "Division",
  "interval_start_of_archive": "Start of archive",
  "interval_end_of_archive": "End of archive",
  "interval_setting_intervals": "Setting intervals",
  //ChartMenuPens
  "chartmenupens_value": "Value",
  "chartmenupens_last": "Last",
  "chartmenupens_average": "Average",
  "chartmenupens_minimum": "Minimum",
  "chartmenupens_maximum": "Maximum",
  "chartmenupens_difference": "Difference",
  "chartmenupens_type": "Type",
  "chartmenupens_color": "Color",
  "chartmenupens_name": "Name",
  "chartmenupens_type_of_value": "Type of value",
  "chartmenupens_select_pens": "Select pens",
  "chartmenupens_group_setting": "Group setting",
  "chartmenupens_changing": "Changing the pens settings",
  //State
  "state_standart_group": "Standart group",
  //Datatable
  "datatable_export_data": "Export data",
  "datatable_columnFilterEnabled": "Column filtering enabled",
  "datatable_columnFilterDisabled": "Column filtering disabled",
  "datatable_changing_an_entry": "Changing an entry",
  "datatable_edit": "Edit",
  "incorrect_value_entered": "Incorrect value entered",
  "use_positive_numbers_or_*.": "The value entered is invalid. Use positive numbers or *.",
  //Mark
  "mark_edit_comment": "Edit comment",
  "mark_add_comment": "Add comment",
  "mark_delete": "Delete mark",
  "mark_enter_comment": "Enter a comment",
  "mark_user": "USER",
  "mark_comment": "COMMENT",
  "mark_time": "TIME",
  //Polygon
  "polygon_primitive_error": "Primitive error",
  "polygon_enable_set_value": "Enable to set value",
  "polygon_geometry_for": 'the "Geometry" parameter for',
  //trendbase
  "trendbase_print_chart": "Printing a chart",
  "trendbase_print_chart_to_printer": "Printing a chart to a printer",
  "trendbase_pen_removed": "Pen removed",
  "trendbase_added": "Added",
  "trendbase_pens": "pens",
  "trendbase_adding_removing": "Adding/removing pens",
  //Upload file
  "upload_upload_file": "Upload file",
  "upload_drag_and_drop": "Drag and drop file here to upload",
  "upload_download": "Download",
  "upload_select": "Select file",
  "upload_file_added": "File added",
  "upload_file_complete": "File download complete",
  "upload_file_error": "File upload error",
  //basic
  "basic_image": "Image",
  "basic_not_standart": "does not meet the accepted standard",
  //main
  "main_show_password": "Show password",
  /*Toolbar log*/
  "jornal_toolbar_acknowledgePage": "Acknowledge on page",
  "jornal_toolbar_acknowledgeAll": "Acknowledge all",
  "jornal_toolbar_export": "Export",
  "jornal_toolbar_print": "Print",
  "jornal_toolbar_priority": "Priority",
  "jornal_toolbar_objectTree": "Object tree",
  "jornal_toolbar_timeFilter": "Enable time filter",
  "jornal_toolbar_goDate": "Go to date",
  "jornal_toolbar_showLegend": "Show legend",
  "jornal_toolbar_autoscroll": "Autoscroll",
  "jornal_toolbar_showFilter": "Show filter",
  "jornal_toolbar_reset": "Reset",
  "jornal_toolbar_goFirstPage": "To first page",
  "jornal_toolbar_goLastPage": "To last page",
  /*Priority log*/
  "jornal_priority_title": "Priority",
  "jornal_priority_filter": "Filter",
  /*Time filter log*/
  "jornal_timeFilter_skipped": "Skipped",
  "jornal_timeFilter_displayedInterval": "Displayed interval",
  "jornal_timeFilter_numberMessages": "Number of messages",
  "jornal_timeFilter_time": "Time",
  "jornal_timeFilter_autoscrollTime": "Autoscroll Time",
  /*Go to date log*/
  "jornal_goDate_title": "Go to date",
  /*Log*/
  "jornal_filterTitle": "Filter1",
  "jornal_columnFilterEnabled": "Column filtering enabled",
  "jornal_columnFilterDisabled": "Column filtering disabled",
  "jornal_contains": "contains",
  "jornal_equal": "equal to",
  "jornal_equally": "equal to",
  "jornal_acknowledged": "Acknowledged",
  "jornal_enterComment": "Enter comment",
  "jornal_addEventFavoriteTooltip": "Add event to favorites by double-clicking the cell",
  "jornal_filterEnabled": "Filter enabled",
  "jornal_filterDisabled": "Filter disabled",
  "jornal_acknowledgedMessages": "messages",
  "jornal_savingMessagesFile": "Saving messages to file",
  "jornal_ack": "Ack",
  "journal_time": "Time",
  "journal_message": "Message",
  "journal_priority": "Priority",
  "journal_withdrawal_time": "Withdrawal time",
  "journal_kvit_time": "Acknowledgment time",
  "journal_user": "User",
  "journal_comment": "Comment",
  "journal_event": "Event",
  "journal_kvitirovanie": "Acknowledgement",
  "journal_appearance": "Appearance",
  "journal_login": "Login",
  "journal_logout": "Logout",
  "journal_startSession": "start of the session",
  "journal_activation_time": "Activation time",
  "journal_active_messages": "Active messages",
  "journal_icon": "Icon",
  "journal_EventFullObjectName": "Full object name",
  "journal_EventObjectName": "Object",
  "journal_EventSourceName": "Source",
  "journal_EventSourceOrObjectName": "Source or object",
  "journal_EventDescription": "Description",
  "journal_EventDescriptionOrSource": "Description or source",
  "journal_EventState": "State",
  "journal_EventStateSeverity": "State+Severity",
  "journal_ClientAddress": "IP address/Hostname",
  "journal_ClientIpAddress": "IP address",
  "journal_ClientHostName": "Hostname",
  "journal_window": "Window",
  "journal_ExternalPath": "External Path",
  "journal_ActiveTime": "Activation timestamp",
  "journal_Severity": "Priority",
  "journal_Active": "Activity",
  "journal_InactiveTime": "Deactivation timestamp",
  "journal_value": "Value",
  "journal_MaxChangeRate": "Maximum change rate",
  "journal_disappearance": "Disappearance",
  "journal_safety": "Safety",
  "journal_alarm": "Alarm",
  "journal_object": "Object",
  "journal_attention": "Attention",
  "journal_ALARM": "ALARM",
  "journal_objects": "Objects",
  "journal_printMessages": "Printing messages to a printer",
  "journal_ack": "Ack",
  "journal_AckedTime": "Acknowledgement timestamp",
  //dictionary toolbar
  "dictionary_toolbar_reload": "Reload",
  "dictionary_toolbar_add": "Add",
  "dictionary_toolbar_edit": "Edit",
  "dictionary_toolbar_delete": "Delete",
  "dictionary_toolbar_reset": "Reset",
  //dictionary
  "dictionary_title_filter_for": "Filter for",
  "dictionary_contains": "contains",
  "dictionary_equals": "equals",
  "dictionary_column_filtering_enabled": "Column filtering enabled",
  "dictionary_column_filtering_is_disabled": "Column filtering is disabled",
  "dictionary_adding_a_record": "Adding a record",
  "dictionary_addition": "Addition",
  "dictionary_changing_an_entry": "Changing an entry",
  "dictionary_editing": "Editing",
  "dictionary_deleting_a_record": "Deleting a record",
  "dictionary_export_data": "Export data",
  "dictionary_city": "City",
  "dictionary_street": "Street",
  "dictionary_house": "House",
  "dictionary_building": "Building",
  //дерево
  "tree_clear_tooltip" : "Restore to Default",
  //легенда
  "legend_tooltip_visible": "Visibility",
  "legend_title_pen": "Pen",
  "legend_tooltip_pen": "Pen graphic attributes",
  "legend_title_name": "Name",
  "legend_tooltip_name": "Pen name",
  "legend_title_source": "Source",
  "legend_tooltip_source": "Path to the variable associated with the pen",
  "legend_title_group": "Group",
  "legend_tooltip_group": "Pen group",
  "legend_title_units": "Units",
  "legend_tooltip_units": "Measurement units",
  "legend_title_value": "Value",
  "legend_tooltip_value": "The value of the variable associated with the pen",
  "legend_title_avarage": "Average value",
  "legend_tooltip_avarage": "Average value",
  "legend_title_comment": "Comment",
  "legend_tooltip_comment": "Parameter comment",
  "legend_title_lasttime": "Last modified time",
  "legend_tooltip_lasttime": "Time of last value change",
  "legend_title_isbad": "Quality",
  "legend_tooltip_isbad": "StatusCode",
  "legend_title_scalemin": "Scale min",
  "legend_tooltip_scalemin": "Minimum scale value",
  "legend_title_scalemax": "Scale max",
  "legend_tooltip_scalemax": "Maximum scale value",
  "legend_title_lolo": "LoLo",
  "legend_tooltip_lolo": "Lower alarm setpoint. (LoLo)",
  "legend_title_lo": "Lo",
  "legend_tooltip_lo": "Lower warning setpoint. (Lo)",
  "legend_title_hi": "Hi",
  "legend_tooltip_hi": "Upper warning setpoint. (Hi)",
  "legend_title_hihi": "HiHi",
  "legend_tooltip_hihi": "Upper alarm setpoint. (HiHi)",
  "legend_title_start": "Initial value",
  "legend_tooltip_start": "Variable value at the beginning of the range",
  "legend_title_min": "Min value",
  "legend_tooltip_min": "Minimum variable value in range",
  "legend_title_max": "Max value",
  "legend_tooltip_max": "Maximum variable value in range",
  "legend_title_end": "End value",
  "legend_tooltip_end": "Variable value at the end of the range",
  "legend_menu_type_graph_title": "Graph type",
  "legend_menu_type_graph_linear": "Linear",
  "legend_menu_type_graph_stepped": "Stepped",
  "legend_menu_thickness_title": "Thickness",
  "legend_menu_color_title": "Color",
  "legend_menu_type_line_title": "Line style",
  "legend_menu_type_line_line": "Line",
  "legend_menu_type_line_dotted": "Dotted line",
  "legend_menu_type_line_points": "Points",
  "legend_menu_type_point_title": "Point type",
  "legend_menu_point_size_title": "Point size",
  "legend_menu_scale_visibility_title": "Scale visibility",
  "legend_menu_ddding_constants_title": "Adding constants",
  "legend_menu_autoscaling_title": "Autoscaling",
  "legend_scale_no_use": "The scale is not used",
  "legend_scale_no_use_tooltip": "Pen is not selected as the main feather in the group",
  "legend_autoscaling_on": "Autoscaling",
  //numericupdown
  "numericupdown_tooltip": "from {Min} to {Max}",
  "numericupdown_tooltip_without_min": "to {Max}",
  "numericupdown_tooltip_without_max": "from {Min}",
  "numericupdown_popup_description_start": "Invalid value. Enter number",
  // paneltabcontrol Панель вкладок
  "paneltabcontrol_tab_not_found_title": "Tab \"{}\" not found",
  "paneltabcontrol_tab_not_found_text": "Warning 'Active tab': the specified tab number does not exist in the tab panel \"{}\"",
  "paneltabcontrol_tab_is_hidden_title": "Tab \"{}\" is hidden",
  "paneltabcontrol_tab_is_hidden_text": "Warning 'Active tab': the specified tab number refers to a hidden tab in the tab panel \"{}\". The action will be ignored",
  //Interval
  "interval_millisecond": "Millisecond",
  "interval_second": "Second",
  "interval_minute": "Minute",
  "interval_hour": "Hour",
  "interval_day": "Day",
  "interval_month": "Month",
  "interval_year": "Year",
  //Short interval
  "interval_short_millisecond": "Ms",
  "interval_short_second": "Sec",
  "interval_short_minute": "Min",
  "interval_short_hour": "Hour",
  "interval_short_day": "Day",
  "interval_short_month": "Mon",
  "interval_short_year": "Year",
  "interval_from": "From",
  "interval_to": "To",
  //upload
  "upload_drag": "To select a file, click the button or drag it here",
  /*buttons*/
  "cancel": "Cancel",
  "apply": "Apply",
  "choose": "Select",
  "delete": "Delete",
  "confirm": "Confirm",
  "all": "All",
  "ok": "Оk",
  "open": "Open",
  "import": "Import",
  /*bool*/
  "true": "Yes",
  "false": "No",
  //any
  "search": "Search",
  "loading": "Loading",
  "indefinitely": "Indefinitely",
  "warning": "Warning",
  "title_error_setting_value": "Error setting value",
  "title_error_setting_link": "Error setting value via link",
  "title_error_creating_link": "Error creating link",
  "title_error_setting_trigger": "Error setting trigger",
  "request_cannot": "the request cannot be parsed by the JSON parser",
  "invalid_parametr": "invalid parameter/selection ID passed",
  "connection_error": "Connection error",
  "number_of_connection": "The allowed number of connections to the server has been exceeded",
  "visualisation_isnot_available": "visualization is not available in this project",
  "request_method_not_recognized": "request method not recognized",
  "from_lower": "from",
  "to_lower": "to",
  // СПИСОК ОШИБОК HMI
  //Окно не найдено
  "title_window_not_found": "Window not found",
  // Окно по пути ... не найдено
  "window_not_found_path": "Window at path {} not found",
  // Образ не соответствует принятому стандарту
  "image_not_standart": "The image {} id={} does not meet the accepted standard",
  // В графике XY отсутствуют перья
  "chartXY_missing_pens": `XY {} graphics are missing pens`,
  // Превышен лимит перьев на диаграмме. Перо не было добавлено
  "diagram_pens_limit": `The pen limit on the chart has been exceeded. Pen {} was not added`,
  // Ошибка получения данных
  "title_dictionary_error_retrieving_data": "Data receiving error",
  // Ошибка сохранения
  "title_dictionary_error_saving": "Save error",
  // Ошибка удаления
  "title_dictionary_error_deleting": "Uninstall error",
  // Невозможно задать значение параметру "Геометрия" для 
  "polygon_cannot_set_value": 'Cannot set a value {} for the Geometry parameter for id={} {}',
  // Не все параметры были добавлены в тренд ... не добавлено) из-за превышения ограничения
  "trend_not_all_added_params": `Not all parameters were added to the trend ({}) due to exceeding the limit ({})`,
  // Ни один параметр не добавлен из-за превышения ограничения
  "trend_not_one_added_params": `No parameters were added ({}) due to exceeding limit ({})`,
  // Выбранный файл не является CSV-файлом
  "trendcsv_import_file_not_svg": `The selected file is not a CSV file`,
  // Импортируемый файл повреждён или имеет неверный формат
  "trendcsv_import_file_broken": `The imported file is corrupted or has an invalid format`,
  // Некорректно задана маска ввода
  "input_mask_incorrect": "The input mask is set incorrectly",
  // Недопустимое значение цвета {0} для перевода в матрицу. По умолчанию будет использоваться единичная матрица
  "color_error_matrix": "Invalid color value {} for translation into matrix. By default the identity matrix will be used",
  // Ошибка параметра
  "title_parametr_error": "Parameter error",
  // Невозможно получить параметр
  "cannot_get_parametr": `Cannot get parameter {}/{}`,
  // Не найдено действие
  "title_action_not_found": "Action not found",
  // Не найдено действие
  "action_not_found_error": "Action not found {} ControlId={}",
  // Ошибка операции
  "title_operation_error": "Operation error",
  // Элемент с id не найден
  "element_id_not_found": `Element with id {} not found`,
  // Ошибка установки значения на параметр в контроле
  "value_setting_error": "Error setting value {} to parameter {} in control id={}{}",
  "link_setting_error": "Error setting value {} via link {} to parameter {} in control id={} \"{}\"",
  "link_creating_error": "Error creating link to parameter {} in control id={} \"{}\"",
  "trigger_setting_error": "Error setting value {} in trigger condition with id={} to trigger condition parameter with id={} in control id={} \"{}\"",
  // Нет прав на открытие заданного стартового окна
  "not_rights_to_open": "You do not have permission to open the specified start window. Check the rights settings for this user",
  // Нет прав на заданное окно
  "title_not_rights_to_window": "No rights to the specified window",
  // Соединение установлено
  "title_connection_established": "Connection established",
  // Подключение к ... успешно установлено
  "connection_success": 'Connection to {} successfully established',
  // Звук не найден
  "sound_not_found": "Sound not found: {}",
  // Ошибка входа пользователя
  "authorization_error_login": "Login error for user {}. {} || {}",
  // Вызов POU ошибка
  "title_call_pou_error": "Call POU ERROR",
  // Айди программы 
  "program_id": "Program ID {}",
  // Предупреждение образа
  "title_skin_warning": "Image warning",
  // Неправильный идентификатор тренда
  "title_wrong_id_trend": "Wrong trend ID",
  // ID легенды ... установил неправильный идентификатор тренда ...
  "wrong_id_trend_set": "legend ID: {} set wrong trend ID: {}",
  // Ошибка записи файла
  "title_write_file_error": "Write file error",
  // Ошибка записи файла
  "write_file_errors": "Write files error: {} {} {}",
  // Невозможно подписаться на параметр 
  "unable_to_subscribe_to_parameter": "Unable to subscribe to parameter",
  // FROM id ... TO id ... Значение ... не может быть преобразовано в формат ...
  "cannot_be_converted": "{} value cannot be converted to {} format",
  "open_win_error": "Error while opening window ",
  //PathResolver
  "pathresolver_resources": "Resources",
  "pathresolver_windows": "Windows",
  "pathresolver_graphic_user_interface": "Graphic user interface",
  //Bim
  "bim_focus_object_error": 'Error executing "Focus object" BIM server command',
  "bim_no_websocket_connection":  "There is no WebSocket connection",
  //permission
  "action": "Action",
  "control": "Control",
  "open_window": "Open window",
  "change_users": "Change users",
  "change_password": "Change password",
  "journal_group_ack": "Group message ack",
  "journal_use_filters": "Using filters in the journal",
  "journal_print": "Print messages",
  "journal_save": "Export messages",
  "trend_add_pens": "Change pens",
  "trend_change_pens": "Change pens, change scale",
  "trend_save": "Export trend",
  "trend_print": "Print trend",
  "data_table_edit": "Editing table cells",
  "data_table_filter": "Using filters in a table",
  "insufficient_permissions": "Insufficient permissions to perform the action",
  //Mark
  "marks": "Marks",
  "posters": "Posters",
  "installed_individually": "'Транзит разомкнут','Работа под напряжением' and dispatcher signs are installed individually.",
  "mark_selection": "Mark selection",
  "poster_selection": "Poster selection",
  "no_image": "No image",
  "dispatcher_marks": "Dispetcher marks",
  "delete_all_marks": "Delete All Marks",
  "show_all_marks": "Show All Marks",
  "hide_all_marks": "Hide All Marks",
  "break_connection": "Break Connection",
  "edit_comment": "Edit Comment",
  "add_comment": "Add Comment",
  "no_more_connection": " Just single connection with each mark are allowed",
  "all_marks_hide": "All marks added to the window are hidden",
  "mark_user_comment": "Comment",
  "mark_username": "User",
  "mark_last_change": "Last change",
  "uncorrect_data": "Uncorrect data",
  "unavailable_side": "The party is unavailable for communication",
  "poster": "Poster",
  "mark": "Mark",
  "delete_all": "Delete all",
  "show_all": "Show all",
  "hide_all": "Hide all",
  "close": "Close",
  "mark_priority": "Mark priority",
  "poster_priority": "Poster priority",
  "delmark": "mark",
  "delposter": "poster"
} as const